import React, { useEffect, useState } from 'react';
import './header1.css';
import { Link, useLocation } from 'react-router-dom';

const Header1 = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState('');

  useEffect(() => {
    // Update current page whenever the location changes
    setCurrentPage(location.pathname);
  }, [location]);


  return (
    <div>
      <div
        className="desktop-4ma">

        <img className="image-iconm" alt="" src="/logo.png" />
        
        <p className='titlename'>VREON TECH INDIA PVT LTD</p>


        <div className="about-parent4m">
          <b className="aboutm">
            <Link className={`menuaa ${currentPage === "/about" ? 'about' : ''}`} to="/about">ABOUT</Link>
          </b>
          <b className="servicem">
            <Link className={`menuaa ${currentPage === "/service" ? 'service' : ''}`} to="/service">SERVICES</Link>
          </b>
          <b className="portfoliom">
            <Link className={`menuaa ${currentPage === "/portfolio" ? 'portfolio' : ''}`} to="/portfolio">PORTFOLIO</Link>
          </b>
          <b className="ourproducts1m">
            <Link className={`menuaa ${currentPage === "/products" ? 'products' : ''}`} to="/products">PRODUCTS</Link>
          </b>
          <b className="contactm">
            <p className="contactm1">
              <Link className={`menuaa ${currentPage === "/contact" ? 'contact' : ''}`} to="/contact">CONTACT</Link>
            </p>
          </b>
          {/* Show this section only on mobile devices */}
          <div className="transform-your-vision mobile-only">
            <div className="frame-childm1">
              <b className="homem1">

                <Link to="/" className="linkk" >HOME</Link>

              </b>



            </div>

          </div>
          <div className="frame-childm" />
          <b className="homem">

            <Link to="/">HOME</Link>

          </b>

        </div>

        <div className='dummydiv'>

        </div>


      </div>
    </div>

  );
};

export default Header1;
